module.exports = __webpack_public_path__ + "img/SpecialistTotPatStu.209a26b6.jpg";